import { BsSearch, BsXCircleFill } from "react-icons/bs";
import styled from "styled-components";

const Wrapper = styled.form`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.85rem 1rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.pill};
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(14px);
`;

const SearchIcon = styled(BsSearch)`
  color: ${({ theme }) => theme.colors.textSoft};
  flex-shrink: 0;
`;

const Input = styled.input`
  width: 100%;
  border: 0;
  outline: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.text};
  font-size: 0.98rem;

  &::placeholder {
    color: ${({ theme }) => theme.colors.textSoft};
  }
`;

const ClearButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.textSoft};
  cursor: pointer;
  flex-shrink: 0;
`;

function SearchBar({ value, onChange, onClear }) {
  return (
    <Wrapper role="search" aria-label="Buscar filmes" onSubmit={(event) => event.preventDefault()}>
      <SearchIcon aria-hidden />
      <Input
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Buscar por filme, tema ou clima da noite"
        aria-label="Buscar filmes por titulo"
      />
      {value ? (
        <ClearButton type="button" onClick={onClear} aria-label="Limpar busca">
          <BsXCircleFill size={18} />
        </ClearButton>
      ) : null}
    </Wrapper>
  );
}

export default SearchBar;
